
import { createAction } from "@reduxjs/toolkit";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initSystem = createAction<any>("general/initSystem");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const closeSystem = createAction<any>("general/closeSystem");
